<template>
  <div>
    <vs-input
      class="w-full"
      :label-placeholder="placeholder"
      v-model="nominalShow"
      name="nominal"
      type="text"
      @input="setRupiah"
      v-validate="'required'"
    />
    <span class="text-danger text-sm" v-show="errors.has('nominal')">{{
      errors.first("nominal")
    }}</span>
  </div>
</template>

<script>

export default {
  props: {
    placeholder:{
      type: String,
      default: 'Nominal Aset (Dalam Rp.)'
    },
    defaultNominal: {
      default : null
    }
  },
  data(){
    return {
      nominalShow : null,
      nominal: null,
    }
  },
  mounted(){
    this.setDefaultNominal();
  },
  methods: {
    setRupiah(event){
      let stringNumber = event.replace(/[^,\d]/g, '').toString();
			let split = stringNumber.split(',');
			let sisa = split[0].length % 3;
			let rupiah = split[0].substr(0, sisa);
			let ribuan = split[0].substr(sisa).match(/\d{3}/gi);
 
			if(ribuan){
				let separator = sisa ? '.' : '';
				rupiah += separator + ribuan.join('.');
			}
 
      rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
      this.nominalShow = rupiah;

      let nominal = rupiah.replaceAll('.','');
      this.nominal = nominal.replace(',','.');

      this.$emit('input',this.nominal);
    },
    setDefaultNominal(){
      if(this.defaultNominal != null){
        this.setRupiah(this.defaultNominal.toString().replace('.',','));
      }
    }
  }
};
</script>
